import {Factory, Module} from 'app/decorators';
import UserService from './user';
import Config from './config';
import AuthService from './auth';

@Module({
    name: 'app.services.init',
    modules: [UserService, Config, AuthService],
})
@Factory(
    'InitService',
    function($q, $rootScope, AuthService, UserService, Config, PermPermissionStore){
        "ngInject";
        return function(){
            if (!AuthService.isLoggedIn) {
                return $q.resolve();
            }
            // Global, route-independent: keeps the offline cache warm no matter
            // which page the user is on, and re-checks every 24h without a reload.
            if (window.ReactBridge) {
                window.ReactBridge.startOfflinePrefetchScheduler();
            }
            PermPermissionStore.clearStore();
            return $q.all([UserService.refresh(), Config.refresh()]).then(function(){
                $rootScope.$state.test = Config.$config.env === "test" ? true : false;
                $rootScope.$state.staging = Config.$config.env === "staging" ? true : false;

                // Expose the real logged-in user to the shared React/Angular store,
                // so React components can read it via `useStore(appStore, s => s.currentUser)`.
                if (window.ReactBridge) {
                    window.ReactBridge.store.getState().setCurrentUser(UserService.$user);
                }

                for (let perm of UserService.$user.perms) {
                    PermPermissionStore.definePermission(perm, () => true);
                }
            })
        }
    }
)
export default class F {}



// WEBPACK FOOTER //
// ./src/app/services/init.js